// material-ui
import * as React from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { styled } from '@mui/material/styles'
import { PropagateLoader } from 'react-spinners'

// styles
const LoaderWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1301,
  width: '100%'
})

// ==============================|| LOADER ||============================== //
const Loader = () => (
  <LoaderWrapper>
 
    <div className="min-h-screen auth-bg pb-[5%]">
    <LinearProgress color="primary" />
      </div>
  </LoaderWrapper>
)

export default Loader
